import { createStore } from 'vuex'

export const useHistoryStore = createStore('history', {
  state: () => ({
    historyStack: []
  }),
  actions: {
    push (route) {
      // 避免重复添加连续相同路由  未使用
      if (this.historyStack[this.historyStack.length - 1]?.path !== route.path) {
        this.historyStack.push({
          path: route.path,
          name: route.name,
          meta: route.meta
        })
      }
    },
    clear () {
      // 未使用
      this.historyStack = []
    }
  }
})
